import FrontendRoutesBase from './FrontendRoutesBase';
import { PATH_PARAM_DASHBOARD } from '../PATH_PARAM';

export default class CallRoutes extends FrontendRoutesBase {
  root = this.getDBPath(PATH_PARAM_DASHBOARD.call.root);
}
